var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15C18 14.4477 17.5523 14 17 14H15C14.4477 14 14 14.4477 14 15V17C14 17.5523 14.4477 18 15 18H17C17.5523 18 18 17.5523 18 17V15Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.5C11 9.22386 11.2239 9 11.5 9C11.7761 9 12 9.22386 12 9.5V11H14V9.5C14 9.22386 14.2239 9 14.5 9C14.7761 9 15 9.22386 15 9.5V11H17V9.5C17 9.22386 17.2239 9 17.5 9C17.7761 9 18 9.22386 18 9.5V11H20V9.5C20 9.22386 20.2239 9 20.5 9C20.7761 9 21 9.22386 21 9.5V11H22.5C22.7761 11 23 11.2239 23 11.5C23 11.7761 22.7761 12 22.5 12H21V14H22.5C22.7761 14 23 14.2239 23 14.5C23 14.7761 22.7761 15 22.5 15H21V17H22.5C22.7761 17 23 17.2239 23 17.5C23 17.7761 22.7761 18 22.5 18H21V20H22.5C22.7761 20 23 20.2239 23 20.5C23 20.7761 22.7761 21 22.5 21H21V22.5C21 22.7761 20.7761 23 20.5 23C20.2239 23 20 22.7761 20 22.5V21H18V22.5C18 22.7761 17.7761 23 17.5 23C17.2239 23 17 22.7761 17 22.5V21H15V22.5C15 22.7761 14.7761 23 14.5 23C14.2239 23 14 22.7761 14 22.5V21H12V22.5C12 22.7761 11.7761 23 11.5 23C11.2239 23 11 22.7761 11 22.5V21H9.5C9.22386 21 9 20.7761 9 20.5C9 20.2239 9.22386 20 9.5 20H11L11 18H9.5C9.22386 18 9 17.7761 9 17.5C9 17.2239 9.22386 17 9.5 17H11L11 15H9.5C9.22386 15 9 14.7761 9 14.5C9 14.2239 9.22386 14 9.5 14H11V12H9.5C9.22386 12 9 11.7761 9 11.5C9 11.2239 9.22386 11 9.5 11H11V9.5ZM12 12H20V20H12V12Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardware);
export default __webpack_public_path__ + "static/media/hardware.2e1223b4c3d1a1cd7442e641117be894.svg";
export { ForwardRef as ReactComponent };